import { render, staticRenderFns } from "./OrderNotes.vue?vue&type=template&id=5e3f38c8&scoped=true&"
import script from "./OrderNotes.vue?vue&type=script&lang=js&"
export * from "./OrderNotes.vue?vue&type=script&lang=js&"
import style0 from "./OrderNotes.vue?vue&type=style&index=0&id=5e3f38c8&scoped=true&lang=css&"
import style1 from "./OrderNotes.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3f38c8",
  null
  
)

export default component.exports